export function areaToBounds(areaStr: string) {
  const parts = areaStr.split('/').map(parseFloat)

  if (parts.length !== 4 || parts.some(isNaN)) {
    return {
      bounds: null as google.maps.LatLngBoundsLiteral | null,
      center: { lat: 0, lng: 0 },
      googleBounds: null as google.maps.LatLngBounds | null,
    }
  }

  const [north, west, south, east] = parts
  const bounds: google.maps.LatLngBoundsLiteral = { north, south, east, west }
  const center = {
    lat: (north + south) / 2,
    lng: (west + east) / 2,
  }
  const googleBounds = new google.maps.LatLngBounds(
    { lat: south, lng: west },
    { lat: north, lng: east }
  )

  return { bounds, center, googleBounds }
}

export function boundsToArea(bounds: google.maps.LatLngBounds | google.maps.LatLngBoundsLiteral) {
  if ('getNorthEast' in bounds) {
    const ne = bounds.getNorthEast()
    const sw = bounds.getSouthWest()
    return `${ne.lat().toFixed(2)}/${sw.lng().toFixed(2)}/${sw.lat().toFixed(2)}/${ne
      .lng()
      .toFixed(2)}`
  }

  return `${bounds.north.toFixed(2)}/${bounds.west.toFixed(2)}/${bounds.south.toFixed(
    2
  )}/${bounds.east.toFixed(2)}`
}

export function boundsToLiteral(bounds: google.maps.LatLngBounds): google.maps.LatLngBoundsLiteral {
  const ne = bounds.getNorthEast()
  const sw = bounds.getSouthWest()
  return {
    north: ne.lat(),
    south: sw.lat(),
    east: ne.lng(),
    west: sw.lng(),
  }
}
